export default __webpack_public_path__ + "static/media/AreaFitness.cc7f7c2d.svg";